import { getApiURL } from "../constantes";

export class ComunicacionAjax {

	/**
	 * Envia una petición AJAX con los datos especificados y ejecuta la funcionCompletado. Si falla prueba renovando el token.
	 */
	static async sendAjaxRequest<ReturnType = unknown, paramType extends object = object>(type: "GET" | "POST", url: string, data?: paramType): Promise<ReturnType> {
		const opciones: RequestInit = {
			method: type,
			// dataType: "json",
			// cache: false,
			headers: {
				"Content-Type": "application/json;charset=utf-8",
				"Accept": "application/json",
				"API-Key": "%C2%A3Hj8%5ByO%C2%A3FPf(/AMPp+g@d8-%7Bb(2Qp628G&8%25tH0ElTrwcDG3B3/%254w%60%7DX%5EB%3EN7Bh",
				"Authorization": "Bearer " + getToken(),
			},
			body: type == "GET" ? undefined : JSON.stringify(data),
		};

		let queryParams = "";
		if (type == "GET" && data) {
			const params = new URLSearchParams();
			for (const key in data) {
				if (typeof data[key] === "string" || typeof data[key] === "number" || typeof data[key] === "boolean") {
					params.append(key, String(data[key]));
				} else if (Array.isArray(data[key])) {
					data[key].forEach(
						v => params.append(key + "[]", String(v))
					);
				}
			}
			queryParams = "?" + params.toString();
		}

		const fullUrl = getApiURL(url, queryParams);
		const promiseReq = fetch(fullUrl, opciones);

		const res = await promiseReq;
		const body = await res.json() as ReturnType;
		if (!res.ok) {
			throw new HttpError(res.status, "Error en la petición", body);
		}

		return body;
	}


}

function getToken() {
	const tokenStr = localStorage.getItem("token_mrp") ?? "";
	try {
		const token = JSON.parse(tokenStr) as unknown;
		if (typeof token === "string") return token;
		return token as string;
	} catch {
		return tokenStr;
	}
}

export class HttpError extends Error {
	status: number;
	body: unknown;

	constructor(status: number, message: string, body: unknown) {
		super(message);
		this.status = status;
		this.body = body;
	}
}